
const initState = {
    emailAddress: '',
    booleanHomepageEmailSignup: false,

};

const homepageReducer = (state=initState, action) => {


    switch (action.type) {

        case 'ADDED_APLHA_EMAIL':

            return {
                ...state,
                emailAddress: action.emailAddress,
                booleanHomepageEmailSignup: true,
            }
        

        default:

            return state;
           
    }
    


}


export default homepageReducer